import React from 'react';
import { Link } from 'react-router-dom';
import ArrowSvg from  '../svg/arrow';
import Grid from 'material-ui/Grid';
import PropTypes from 'prop-types';
import InViewMonitor from 'react-inview-monitor';
import { isUA } from '../../helper/userAgent';


class contentsTemplate extends React.Component {
  constructor(props){
    super(props)
    // edge�p
    if(isUA('edge')){
      props.showAnim = 'show-scroll-animation';
    }
  }
  
  render() {
    return (
      <InViewMonitor
        classNameNotInView=''
        classNameInView='show-scroll-animation'
      >
        <Grid className={`scroll-animation-cont ${this.props.showAnim}`}>

          <section className={`intro-block ${this.props.reverse}`}>
            <div className={`intro-block-inner bg-${this.props.id}`}>
              <div className="main-inner">
                <div className="intro-box">
                  <div className="intro-cover is-appear is-show-right is-show">
                    <Link className="cover-link" to={this.props.id}>
                    <div className={`cover-title ${this.props.text_position}`}>
                      <div className="mask-slide-in-out"></div>
                      <div className="cover-link-effect"></div>
                      <div className="title-text">
                        <h2 className="font-volt cover-title-h2">{this.props.id.toUpperCase()}</h2>
                        <p className="cont-text color-base">{this.props.comment}</p>
                      </div>
                      <div className="cover-arrow">
                        <ArrowSvg />
                      </div>
                    </div>
                      <picture className="intro-image">
                        <source media="(min-width:601px)" srcSet={this.props.src} />
                        <source media="(max-width:600px)" srcSet={this.props.sp_src} />
                        <img className="cover-image intro-image" width="100%" src={this.props.src}  alt={this.props.comment}/>
                      </picture>
                    </Link> 
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*
          <section className="intro-block">
          <div className="intro-block-inner">
            <div className="main-inner">
              <div className="intro-box">
                <div className="intro-cover is-appear is-show-right is-show">
                  <a href="./service/">
                    <div className="intro-text intro-text-right">
                      <h2>SERVICE</h2>
                    </div>
                    <img src={serviceImage} width="100%" alt="service" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="intro-block l-reverse">
          <div className="intro-block-inner bg-works">
            <div className="main-inner">
              <div className="intro-box">
                <div className="intro-cover ">
                  <a href="./works/">
                  <div className="intro-text intro-text-left">
                    <h2>WORKS</h2>
                  </div>
                  <img className="intro-image" src={worksImage} width="100%" alt="" /></a>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="intro-block">
          <div className="intro-block-inner bg-recruit">
            <div className="main-inner">
              <div className="intro-box">
                <div className="intro-cover is-appear is-show-right is-show">
                  <a href="./service/">
                    <div className="intro-text intro-text-right">
                      <h2>RECRUIT</h2>
                    </div>
                    <img src={recruitImage} width="100%" alt="service" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

            */}
        </Grid>
      </InViewMonitor>
    )
  }
}
contentsTemplate.propTypes = {
  id:PropTypes.string.isRequired,
  src:PropTypes.string.isRequired,
  comment:PropTypes.string.isRequired,
}
contentsTemplate.defaultProps = {
  bg_class: "bg-white-color",
  text_position:"intro-text-left",
  reverse:"",
  
};
export default contentsTemplate


// WEBPACK FOOTER //
// ./src/component/home/contentsTemplate.js